import axios from 'axios'
// import router from '@/router/index'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
let apiPath = '/official'
let apiHost = 'https://tcapi.dangjianwang.com'
if (process.env.NODE_ENV === 'production') {
    apiHost = '{{API_HOST}}'
}
axios.defaults.baseURL = apiHost + apiPath
axios.defaults.withCredentials = true
axios.interceptors.request.use(
    config => {
        // if (store.state.token) {
        //     config.headers.Authorization = `token ${store.state.token}`;
        // }
        return config
    },
    err => {
        return Promise.reject(err)
    })

axios.interceptors.response.use(
    response => {
        // 未登录
    	if (response.data.code === 1004) {
            // let host = location.host;
            // let protocol = location.protocol;
            // location.href = protocol + '//' + host + '/login' + '?redirect=' + encodeURIComponent(location.href)
        }
        return response
    },
    error => {
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        return Promise.reject(error.response.data)
    })

export default axios



// WEBPACK FOOTER //
// ./src/lib/axios.js